import { LitElement, html, css } from 'lit'

export class SideDrawerBtn extends LitElement {
  static styles = css`
    button {
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
      display: flex;
      align-items: center;
    }

    .flex-1 {
      flex: 1 1 0%;
    }

    .justify-start {
      justify-content: flex-start;
    }

    .justify-end {
      justify-content: flex-end;
    }
  `

  static properties = {
    for: { type: String, reflect: true },
    active: { type: Boolean, reflect: true },
    stretch: { type: String },
    closeDrawerOnToggle: { type: String },
  }

  constructor() {
    super()
    this.active = false
    this._toggle = () => {
      this.active = !this.active
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.class = ''
    if (this.stretch === 'right') {
      this.class = 'flex-1 justify-end'
    } else if (this.stretch === 'left') {
      this.class = 'flex-1 justify-start'
    }
    window.MicroBus.on(`${this.for}:toggle`, this._toggle)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.MicroBus.on(`${this.for}:toggle`, this._toggle)
  }

  render() {
    return html`
      <button class="${this.class}" @click=${this._onClick}>
        <slot></slot>
      </button>
    `
  }

  _onClick() {
    window.MicroBus.emit(`${this.for}:toggle`)
    window.MicroBus.emit('igEvents:push', {
      event: `Side Menu - Toggle`,
    })
    if (this.closeDrawerOnToggle) {
      window.MicroBus.emit(`${this.closeDrawerOnToggle}:toggle`)
    }
  }
}

customElements.define('side-drawer-btn', SideDrawerBtn)
